import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import Navbar from '../../components/navbar/index';
import Footer from '../../components/Footer/Footer';

export default function Privacy() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return (
    <>
      <Navbar />

      <main className="bg-slate-50 text-slate-900">
        <section className="max-w-5xl mx-auto px-6 py-16 md:py-20">
          <p className="text-sm font-semibold uppercase tracking-[0.15em] text-teal-700">
            Privacy Policy
          </p>
          <h1 className="mt-3 text-3xl md:text-4xl font-bold text-slate-900">
            Your privacy matters to AQT Direct Limited
          </h1>
          <p className="mt-3 text-base md:text-lg text-slate-700 leading-relaxed">
            AQT Direct Limited ("Company", "we", "our", or "us") is committed to safeguarding the privacy and confidentiality of personal information in compliance with applicable data protection laws and regulatory standards.
          </p>
          <p className="mt-2 text-base md:text-lg text-slate-700 leading-relaxed">
            By submitting your personal information through our website, forms, or any associated communication channels, you expressly consent to the collection, processing, storage, and use of your data in accordance with this Privacy Policy.
          </p>

          <div className="mt-10 space-y-10">
            <section>
              <h2 className="text-xl md:text-2xl font-semibold text-slate-900">
                1. Information We Collect
              </h2>
              <ul className="mt-3 space-y-2 list-disc list-inside text-slate-700 leading-relaxed">
                <li>Identification details (such as name)</li>
                <li>Contact information (phone number, email address, city/location)</li>
                <li>Financial and investment-related information (including investment preferences and capacity)</li>
                <li>Any other information voluntarily provided by you</li>
              </ul>
            </section>

            <section>
              <h2 className="text-xl md:text-2xl font-semibold text-slate-900">
                2. Purpose of Data Processing
              </h2>
              <ul className="mt-3 space-y-2 list-disc list-inside text-slate-700 leading-relaxed">
                <li>To establish communication via call, SMS, WhatsApp, or email</li>
                <li>To provide information regarding investment opportunities, private equity transactions, and advisory services</li>
                <li>To facilitate market research, due diligence, transaction execution, and regulatory compliance support</li>
                <li>To connect you with our affiliated partners, consultants, and professional service providers</li>
                <li>To improve our services, website functionality, and user experience</li>
              </ul>
            </section>

            <section>
              <h2 className="text-xl md:text-2xl font-semibold text-slate-900">
                3. Legal Basis for Processing
              </h2>
              <ul className="mt-3 space-y-2 list-disc list-inside text-slate-700 leading-relaxed">
                <li>Your explicit consent</li>
                <li>Performance of a contract or pre-contractual obligations</li>
                <li>Compliance with applicable legal and regulatory requirements</li>
                <li>Legitimate business interests, provided such interests do not override your fundamental rights</li>
              </ul>
            </section>

            <section>
              <h2 className="text-xl md:text-2xl font-semibold text-slate-900">
                4. Data Sharing and Disclosure
              </h2>
              <p className="mt-3 text-slate-700 leading-relaxed">
                Your personal data may be shared with:
              </p>
              <ul className="mt-3 space-y-2 list-disc list-inside text-slate-700 leading-relaxed">
                <li>Authorized employees and internal teams</li>
                <li>Affiliated entities, partners, and professional advisors (including legal, financial, and compliance consultants)</li>
                <li>Regulatory authorities, government bodies, or law enforcement agencies, where required by law</li>
              </ul>
              <p className="mt-3 text-slate-700 leading-relaxed">
                We do not sell, rent, or publicly disclose your personal data to unauthorized third parties.
              </p>
            </section>

            <section>
              <h2 className="text-xl md:text-2xl font-semibold text-slate-900">
                5. Data Security
              </h2>
              <p className="mt-3 text-slate-700 leading-relaxed">
                We implement appropriate technical and organizational measures to safeguard your personal data against unauthorized access, alteration, disclosure, or destruction. However, no electronic transmission or storage system is entirely secure, and we cannot guarantee absolute security.
              </p>
            </section>

            <section>
              <h2 className="text-xl md:text-2xl font-semibold text-slate-900">
                6. Cookies and Tracking Technologies
              </h2>
              <p className="mt-3 text-slate-700 leading-relaxed">
                Our website may use cookies and third-party tracking tools (including but not limited to Meta and Google technologies) to analyze user behavior, enhance functionality, and support targeted marketing initiatives. By using our website, you consent to such use.
              </p>
            </section>

            <section>
              <h2 className="text-xl md:text-2xl font-semibold text-slate-900">
                7. Data Retention
              </h2>
              <p className="mt-3 text-slate-700 leading-relaxed">
                We retain personal data only for as long as necessary to fulfill the purposes outlined in this policy, unless a longer retention period is required or permitted under applicable laws.
              </p>
            </section>

            <section>
              <h2 className="text-xl md:text-2xl font-semibold text-slate-900">
                8. Your Rights
              </h2>
              <p className="mt-3 text-slate-700 leading-relaxed">
                Subject to applicable laws, you may have the right to:
              </p>
              <ul className="mt-3 space-y-2 list-disc list-inside text-slate-700 leading-relaxed">
                <li>Access, update, or correct your personal data</li>
                <li>Withdraw consent at any time</li>
                <li>Request deletion or restriction of processing</li>
                <li>Object to certain types of data processing</li>
              </ul>
              <p className="mt-3 text-slate-700 leading-relaxed">
                Requests may be made by contacting us through official communication channels.
              </p>
            </section>

            <section>
              <h2 className="text-xl md:text-2xl font-semibold text-slate-900">
                9. Consent
              </h2>
              <p className="mt-3 text-slate-700 leading-relaxed">
                By submitting your information, you acknowledge that you have read, understood, and agreed to this Privacy Policy and consent to the collection, use, processing, and sharing of your personal data as described herein.
              </p>
            </section>
          </div>
        </section>
      </main>

      <Footer />
    </>
  );
}
